/* istanbul ignore file */
import axios from 'axios'
import {API_ENDPOINT,API_ENDPOINT_SUPPORT} from '../../../src/apiConstant'


export const saveDocumentStatus = (data) => {
    return (dispatch) => {
      dispatch({
        type: SAVE_DOCUMENT_STATUS,
        payload: data,
      });
    };
  };

export const getUserToken = ({ data, token }) => {

  
    let url = `${API_ENDPOINT}/api/create-user-ticket-credentials/`
    let config = {
        headers: {
          Authorization: "Token " + token,
          'Content-Type': "application/json"
        }
      }
    return dispatch => new Promise((resolve, reject) => {
        axios.post(url, data,config)
        .then((res) => {
            return resolve(res.data)
        })
        .catch((err) => {
            return reject(err)
        })
    }) 
  }

  export const createNewTicket = ({ dataValue}) => {
    // console.log("datavalue",dataValue)
  
    let url = `${API_ENDPOINT_SUPPORT}/api/v1/tickets/`
    let config = {
        headers: {
          'Authorization':'Basic ' + window.btoa( dataValue.email + ":" + dataValue.token) 
        }
      }
    return dispatch => new Promise((resolve, reject) => {
      axios.post(url, dataValue,config)
        .then((res) => {
          return resolve(res)
        })
         
        .catch((err) => {
          // console.log("datavalue",err)
            return reject(err)
        })
    }) 

  }

  export const fetchTicketsDetails = ({ fetchData }) => {
    // console.log('fetchData',fetchData);
    let url = `${API_ENDPOINT_SUPPORT}/api/v1/ticket_articles/by_ticket/${fetchData.ticketId}`;
      // https://support.paymeindia.in/api/v1/ticket_articles/by_ticket/19896
    let config = {
      headers: {
        Authorization:
          "Basic " + window.btoa(fetchData.username + ":" + fetchData.password),
      },
    };
    return dispatch => new Promise((resolve, reject) => {
      axios.get(url, config)
        .then((res) => {
          return resolve(res)
        })
         
        .catch((err) => {
            return reject(err)
        })
    }) 
  };
  export const fetchAllTickets = ({ fetchData}) => {
     let url = `${API_ENDPOINT_SUPPORT}/api/v1/tickets/search?query=${fetchData.email?fetchData.email:""}`;
     let config = {
         headers: {
           'Authorization':'Basic ' + window.btoa( fetchData.email + ":" + fetchData.token) 
         }
       }
     return dispatch => new Promise((resolve, reject) => {
       axios.post(url, fetchData,config)
         .then((res) => {
           return resolve(res)
         })
          
         .catch((err) => {
             return reject(err)
         })
     }) 
 
   }
